import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";
import { z } from "zod";

// Wave-17 Item 1.1 — CBL disputes list lazy-loaded.
const CBLDisputesList = lazy(() => import("@/pages/CBLDisputes/List/Page"));

const CBLDisputes = () => (
  <div className="flex flex-col w-full min-h-full">
    <SiteHeader header="CBL Disputes" />
    <Suspense fallback={null}>
      <CBLDisputesList />
    </Suspense>
  </div>
);

const numArray = z.preprocess((val) => {
  if (Array.isArray(val)) return val.map(Number); // ['0', '1'] → [0, 1]
  if (typeof val === "string") return [Number(val)]; // '0' → [0]
  if (typeof val === "number") return [val]; // 0 → [0]
  return val; // let Zod yell
}, z.array(z.number()));

const searchSchema = z.object({
  status: numArray.optional(),
  order_by: z.string().optional(),
});

export const Route = createFileRoute("/cbl_disputes/")({
  component: CBLDisputes,
  validateSearch: (s: any) => searchSchema.parse(s),
});
